/*
 * TAKEDA CONFIDENTIAL – Highly Restricted: Do not distribute without prior approval
 *
 * © Copyright (2023) Takeda. All Rights Reserved
 */

import { useCookies } from 'react-cookie';

import { getCookieOptions } from '../../../../domain/cookies/cookies.domain';
import {
  dateToString,
  toOptionalDate,
} from '../../../../domain/dates/dates.domain';
import { TERMS_ACCEPTANCE_DATE_COOKIE } from '../../../authentication/authentication.constants';
import { useContext } from 'react';
import { AcceptTermsContext } from '../../contexts/accept-terms/accept-terms.context';

export const useTermsAcceptanceDate = () => {
  const [cookies, setCookie, removeCookie] = useCookies([
    TERMS_ACCEPTANCE_DATE_COOKIE,
  ]);
  const context = useContext(AcceptTermsContext);

  if (!context) {
    throw new Error(
      'useTerms must be used inside a AcceptTermsContextProvider'
    );
  }

  const acceptanceDate = toOptionalDate(cookies[TERMS_ACCEPTANCE_DATE_COOKIE]) || toOptionalDate(context.accepted);

  const setAcceptanceDate = (acceptanceDate: Date) => {
    setCookie(
      TERMS_ACCEPTANCE_DATE_COOKIE,
      dateToString(acceptanceDate),
      getCookieOptions()
    );
    // writing to the context so the values are available in an iframe
    context.setAccepted(new Date().toString());
  };

  const clearAcceptanceDate = () => {
    removeCookie(TERMS_ACCEPTANCE_DATE_COOKIE, getCookieOptions());
    context.setAccepted(undefined);
  };

  return {
    acceptanceDate,
    clearAcceptanceDate,
    setAcceptanceDate,
  };
};
